import DataProcessingModal from './DataProcessingModal'

export default DataProcessingModal
